import axios from 'axios'
import navigation from '@/mixins/navigation'
import DataLayer from '@/utilities/data-layer'
import submitLoans from '@/mixins/submit/submit-loans'

const POLL_INTERVAL = process.env.VUE_APP_DELAY_POLL_INTERVAL || 5000
const POLL_MAX_DURATION = process.env.VUE_APP_DELAY_POLL_MAX_DURATION || 60000

export default {

  data () {
    return {
      pollDuration: 0,
      skipPLDecline: false
    }
  },

  computed: {
    cduid () {
      return this.$store.state.application.cduid
    },

    maxPollReached () {
      return this.pollDuration === POLL_MAX_DURATION
    },

    productEligbilityEndpoint () {
      // TO DO: Update Endpoint Accordingly
      return `${process.env.VUE_APP_LEAD_API_PERSONAL_LOANS_BASE_URL}partner-decisions/${this.cduid}`
    },

    routeChanged () {
      return this.$store.state.application.routeChanged
    }
  },

  mixins: [
    navigation,
    submitLoans
  ],

  mounted () {
    this.$store.dispatch('setRouteChanged', false)
  },

  methods: {

    /**
     * GET request to product eligibility endpoint
     * @returns Promise
     */
    async fetchProductEligibility () {
      return axios.get(this.productEligbilityEndpoint)
    },

    /**
     * Polls Partner Eligiblity Endpoint unitl it receives a single approval
     */
    async pollProductEligibility (runOnce = false) {
      try {
        if (this.routeChanged) return
        const response = await this.fetchProductEligibility()
        const data = response?.data?.data
        const {
          completed,
          approved,
          partners,
          tu_hit: tuHit,
          flinks_received: flinksReceived,
          partners_timeout: partnersTimeout,
          skipPLDecline
        } = data

        const partnersArray = Object.keys(partners)
        const approvals = partnersArray.length
        this.skipPLDecline = skipPLDecline

        // EDGE CASE SCENARIOS
        if (!tuHit && flinksReceived) {
          if (!('Easy' in partners)) {
            return this.handleApproval('Complete')
          }
        }

        if (tuHit && !flinksReceived) {
          if (completed) {
            return this.handleApproval('Complete')
          } else {
            return this.triggerHandlePolling(runOnce, partners)
          }
        }

        if (tuHit && flinksReceived && partnersTimeout) {
          if (approvals === 1 && 'Foundation' in partners) return this.handleApproval('Foundation')
        }

        // NORMAL SCENARIOS
        if (completed && approvals === 1 && 'Foundation' in partners) return this.handleApproval('Foundation')
        if (completed && approvals === 0) {
          if (!partnersTimeout) await this.$_loans_submitLead()
          return this.handleApproval('none')
        }
        if (approved) {
          if (approvals === 1) {
            const partnerName = partnersArray[0]
            if (partnerName === 'Easy') this.handleEasySkipLogic(partners.Easy)
            return this.handleApproval(partnerName)
          } else {
            return this.handleApproval('Complete')
          }
        } else {
          this.triggerHandlePolling(runOnce, partners)
        }
      } catch (error) {
        console.warn(error)
        return this.$_navigation_handleNext()
      }
    },

    async handleApproval (partnerName) {
      if (!this.maxPollReached) DataLayer.pushObject({ event: 'spring_ploan_delay_exit_early' })
      this.pollDuration = POLL_MAX_DURATION
      switch (partnerName) {
        case 'Easy':
          this.$store.dispatch('setCustomerEligibility', 'Easy')
          return this.$_navigation_handleNext()
        case 'Foundation':
          this.$store.dispatch('setCustomerEligibility', 'Foundation')
          return this.skipPLDecline ? this.$_navigation_handleNext() : this.$_navigation_handlePLDeclined()
        case 'none':
          await this.$_loans_submitLead()
          return this.$_navigation_handleSorry()
        default:
          await this.$_loans_submitLead()
          return this.$_navigation_handleNext()
      }
    },

    handlePolling (partners) {
      if (this.maxPollReached) {
        const partnersArray = Object.keys(partners)
        const approvals = partnersArray.length
        if (approvals === 1 && 'Foundation' in partners) return this.handleApproval('Foundation')
        DataLayer.pushObject({ event: 'spring_ploan_delay_exit_full_duration' })
        // if FE times out, set to Thank You Page and agent will contact customer
        return this.handleApproval('Complete')
      } else {
        // poll
        this.pollDuration = this.pollDuration + POLL_INTERVAL
        setTimeout(() => {
          this.pollProductEligibility()
        }, POLL_INTERVAL)
      }
    },

    handleEasySkipLogic (data) {
      const {
        poa_required: poaRequired,
        poi_required: poiRequired
      } = data
      if (poaRequired === false) {
        DataLayer.pushObject({ event: 'spring_ploan_address_verify_step_bypass' })
        this.$store.dispatch('setPOARequired', false)
      }
      if (poiRequired === false) {
        DataLayer.pushObject({ event: 'spring_ploan_income_verify_step_bypass' })
        this.$store.dispatch('setPOIRequired', false)
      }
    },

    triggerHandlePolling (runOnce = false, partners) {
      if (runOnce) {
        return this.$_navigation_handleNext()
      } else {
        this.handlePolling(partners)
      }
    }
  }
}
